/** @format */

import {Box, BoxProps} from '@mui/material';
import {Trans} from 'react-i18next';

import {Description, RestrictionBlockRoot, RestoreButton, TextBlock, Title} from './styles';

interface RestrictionBlockProps extends Omit<BoxProps, 'onClick'> {
  onRestoreClick?: () => void;
}

const defaultHandleRestore = () => {
  try {
    window.carrotquest?.open({conversation: 'new'});
  } catch {
    // Carrot Quest may be blocked by ad blockers
  }
};

const RestrictionBlock = ({onRestoreClick, ...rootProps}: RestrictionBlockProps) => {
  const handleRestore = onRestoreClick ?? defaultHandleRestore;

  return (
    <RestrictionBlockRoot data-testid='restriction-block' {...rootProps}>
      <TextBlock>
        <Title>
          <Trans>Чтобы создавать проекты, обратитесь в поддержку</Trans>
        </Title>
        <Description>
          <Box component='span'>
            <Trans>
              Вы превысили ограничения тарифа и мы временно ограничили вам возможность создавать
              проекты
            </Trans>
          </Box>
          <Box component='span'>
            <Trans>Свяжитесь с нами, чтобы восстановить права аккаунта</Trans>
          </Box>
        </Description>
      </TextBlock>
      <RestoreButton onClick={handleRestore} data-testid='restore-rights-button'>
        <Box
          component='span'
          className='material-symbols-outlined'
          sx={{
            '&.material-symbols-outlined': {
              fontSize: '20px',
            },
          }}
        >
          build
        </Box>
        <Trans>Восстановить права</Trans>
      </RestoreButton>
    </RestrictionBlockRoot>
  );
};

export default RestrictionBlock;
